<template>
  <div v-if="isAdmin" class="panel-admin-body">
    <div class="title w-100">{{ title }}</div>
    <div class="moat-list container">
      <div class="unique-codes-section border-bottom mt-3">
        <div class="d-flex w-100 flex-column">
          <div class="row">
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="filterBySector" class="mr-1 w-100">Initiative Set</label>
                <select id="sector" name="sector" class="custom-select required" v-model="sector_id" @change="filterMoatNameOptions">
                  <option
                      v-for="(sector_option, idxSectorOptions) in this.sector_options"
                      v-bind:value="sector_option.value"
                      v-bind:key="idxSectorOptions"
                  >
                      {{ sector_option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="filterByStatus" class="mr-1 w-100">Moat Name</label>
                <select id="moatName" name="moatName" class="custom-select required" v-model="moatName">
                  <option
                      v-for="(moat_option, idxMoatOptions) in this.moat_options"
                      v-bind:value="moat_option.value"
                      v-bind:key="idxMoatOptions"
                  >
                      {{ moat_option.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <filter-buttons @reset="reset" @filterData="filterData" :is-data-filtering="isDataFiltering" :is-filter-resetting="executeReset"/>
        </div>
      </div>
      <div class="button-container pt-1 pb-1">
        <div class="button-left">
            <div class="pr-2">
                <a href="#" @click="displayDeleteConfirmation(deleteMoatInitiatives,this.moatInitiativeIdsToDelete,'Delete Moat Initiatives','Are you sure you want delete the selected moat initiatives ?')">
                <button type="button" class="btn btn-primary delete-card" id="DeleteMoatInitiative" :disabled="!deleteButtonEnabled">
                    Delete Rows 
                    <span class="ml-auto">
                    <font-awesome-icon :icon="['fa', 'minus-circle']" />
                    </span>
                </button>
                </a>
            </div>
        </div>
        <div class="button-right">
          <a class="pr-2" href="#" @click="$modal.show('import-moat-data-file')">
            <button type="button" class="btn btn-primary">
              <span class="align-text-bottom">Import Roadmap Initiative <font-awesome-icon :icon="['fas', 'upload']"/></span>
            </button>
          </a>
          <a href="/api/v1/admin/download-moat-initiative-import-template" @click.prevent="downloadItem()" id="DownloadMoatImportTemplate">
            <button type="button" class="btn btn-primary">
              <span class="align-text-bottom">Download Roadmap Initiative Template <font-awesome-icon :icon="['fa', 'download']"/></span>
            </button>
          </a>
        </div>
      </div>

      <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
        <thead></thead>
        <tbody></tbody>
      </table>
    </div>
    <vue-modal ref="import-moat-data-file" name="import-moat-data-file" :width="368" :height="400">
      <div class="container">
        <div class="form-group form-row p-2">
          <h5 class="font-weight-bold">Import Roadmap Initiative Data</h5>
        </div>
        <div class="form-group form-row p-2">
          {{ returnMessage }}
        </div>
        <div class="form-group form-row">
          <span class="pr-2">Select a file to upload</span>
          <input ref="importMoatFileUpload" type="file" @change="onFileChange" />
        </div>
        <div class="form-group form-row d-flex justify-content-end">
          <button type="submit" class="btn btn-primary float-right ml-2" v-on:click="this.importFile">
            <span>Import File</span>
            <span v-show="getModalLoading()" class="spinner-border spinner-border-sm"></span>
          </button>
          <button
            type="button"
            class="btn btn-primary ml-4"
            @click="closeModal"
          >
            Close
          </button>
        </div>
      </div>
    </vue-modal>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";
import moment from "moment";
Vue.prototype.moment = moment;

import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import AdminService from "../../services/admin.service";
import MoatService from "../../services/moat.service";
import FilterButtons from "../../components/filter/FilterButtons.vue";
import FilterMixins from "../../mixins/FilterMixins.vue";

export default {
  name: "MoatInitiative",
  mixins: [AdminMixins, DataTableMixins, FilterMixins],
  components: {FilterButtons},
  data() {
    return {
      importMoatDataImportFile: "",
      returnMessage: "",
      title: "Roadmap Initiatives",
      moatInitiativeIdsToDelete: [],
      sector_options: [],
      sector_id: 0,
      originalList: [],
      moat_options: [],
      moatName: "",
      table: {
        id: "moat-initiative-table",
        columns: MoatService.getMoatInitiativeTableColumnData(),
        configuration: {
          searching: true,
          responsive: false,
          dom: 'B<"top"if>rt<"bottom"lp><"clear">',
          paging: true,
          select: true,
          destroy: true,
          info: true,
          ordering: true,
          keys: true,
          bSort: false,
          bSortable: true,
          processing: true,
          columnDefs: [
              {
              targets: 0,       // index of the select-all column
              orderable: false  // disable sorting
              }
          ],
          pageLength: 50,  
        }
      },
    };
  },
  methods: {
    async getTableData() {
      this.$root.processServerRequest("Loading table data");
      MoatService.getMoatInitiativeDataList(this.getMoatInitiativeTableDataCallback, this);
    },
    getMoatInitiativeTableDataCallback(response) {
      this.$root.processServerResponse();
      this.originalList = response.data.data;
      this.table.data = this.originalList;
      this.sector_options = MoatService.buildSectorOptionList(this.originalList);
      this.moat_options = MoatService.buildMoatOptionList(this.originalList);
      this.setupTable();
      this.setupRowClick();
    },
    getDownloadFilename() {
      return "Roadmap Initiative Import Template";
    },
    onFileChange: function() {
      this.importMoatDataImportFile = this.$refs.importMoatFileUpload.files[0];
    },
    async importFile() {
      this.$root.processServerRequest("Importing moat initiatives");
      this.setModalLoading(true);
      MoatService.importMoatInitiativeData(this.importMoatDataImportFile, this.importFileCallback, this);
    },
    importFileCallback: function(response) {
      this.$root.processServerResponse();
      this.setModalLoading(false);

      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.returnMessage = response.data.message;
        this.closeModal();
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    closeModal: function() {
      if (this.$refs['import-moat-data-file'] != null) {
        this.$refs['import-moat-data-file'].visible = false;
      }
      this.$router.go(0);
    },
    setupRowClick() {
      const vm = this;
      const th = $('#moat-initiative-table thead').find("th").eq(0);
      th.html('<input type="checkbox" id="select-all" class="text-center"/>');
      if( this.table.dataTable.click == undefined)  {

        this.table.dataTable.on("click", 'input[type="checkbox"]', function(e, dt, type, indexes) {
            var $row = $(this).closest("tr");
            var data = vm.table.dataTable.row($row).data();
            if (!$.isEmptyObject(data)) {
                if (e.target.checked) {
                    if (!vm.moatInitiativeIdsToDelete.includes(data.moatInitiativeId)){
                        vm.moatInitiativeIdsToDelete.push(data.moatInitiativeId);
                    }
                } else {
                    var match = vm.moatInitiativeIdsToDelete.find(x => x === data.moatInitiativeId);
                    if (typeof match !== "undefined") {
                        vm.moatInitiativeIdsToDelete.splice($.inArray(match, vm.moatInitiativeIdsToDelete), 1);
                    }
                }
            }
        });

        $('#select-all').on('click', function(){
          if ($(this).is( ":checked" )) {
              vm.selectAll();
              // Disable ordering for all columns
              const table = $('#moat-initiative-table').DataTable();
              table.columns().every(function () {
                  this.orderable(false);
              });
          } else {
              vm.deselectAll();
              // Re-enable ordering if needed
              const table = $('#moat-initiative-table').DataTable();
              table.columns().every(function () {
                  this.orderable(false);
              });
          }
        });
      }
    },
    deselectAll: function(){
      this.moatInitiativeIdsToDelete = [];
      // uncheck all rows in table
      let vm = this;
      // deselect all checkboxes in DOM at once
      $(vm.table.dataTable.rows().nodes()).find('input[name="moatInitiativeId[]"]').prop('checked', false);
    },
    addToDownloadSets: function(data){
      if (!$.isEmptyObject(data)) {
          this.moatInitiativeIdsToDelete.push(data.moatInitiativeId);
      }
    },
    selectAll: function(){
      let vm = this;
      vm.table.dataTable.rows({ page: 'current' }).every(function(rowIdx){
          var $row = $( this.node() );
          let data = vm.table.dataTable.row($row).data();
          vm.addToDownloadSets(data);
          $row.find('input[name="moatInitiativeId[]"]').prop('checked', true)
      });
    },
    async deleteMoatInitiatives(result) {
      MoatService.deleteMoatInitiatives(this.moatInitiativeIdsToDelete,this.deleteMoatInitiativesCallback,this);
    },
    deleteMoatInitiativesCallback(response) {
        this.$root.processServerResponse();
        let statusCode = response.data.statusCode;
        if (statusCode == 200) {
            AdminService.displaySuccessMessage({ text: response.data.message });
            this.moatInitiativeIdsToDelete = [];
            this.sector_id = 0;
            this.moatName = "";
            this.getTableData();
        } else {
            AdminService.displayErrorMessage({ text: response.data.message });
        }
    }, 
    filterData: async function(){
      await this.preFilter();
      let vm = this;
      setTimeout(async () => {
        if(this.sector_id != 0){
          this.filteredList =  MoatService.getInitiativesBySector(this.filteredList, this.sector_id);
        }
        if(this.moatName != "") {
          this.filteredList =  MoatService.getInitiativesByMoatName(this.filteredList, this.moatName);
        }
        vm.table.data = vm.filteredList;
        vm.setupTable();
        vm.postFilter();
      }, 200);
    },     
    filterMoatNameOptions(){
      this.moat_options = MoatService.buildMoatOptionList(this.originalList, this.sector_id);
    },
    reset(){
      this.table.data = this.originalList;
      this.sector_options = MoatService.buildSectorOptionList(this.originalList);
      this.moat_options = MoatService.buildMoatOptionList(this.originalList);
      this.sector_id = 0;
      this.moatName = "";         
      this.table.configuration.order = this.tableSortBy;
      this.setupTable();
      this.setupRowClick();
    },
  },
  computed: {
    downloadItemUrl: function() {
      return this.baseUrl + "/api/v1/admin/download-moat-initiative-import-template";
    },
    deleteButtonEnabled: function(){
        return this.moatInitiativeIdsToDelete.length > 0;
    },
  },
  created() {
    if (this.isAdmin) {
      this.getTableData();
      this.table.configuration.order = [
        [2, "asc"], [3, "asc"], [4, "asc"]
      ];
    }
  },
  props: {},
  mounted() {}
};
</script>
